module.exports = __webpack_public_path__ + "static/img/11.196910d4.png";